/* eslint-disable max-lines-per-function */
/* eslint-disable no-var */
/* eslint-disable object-shorthand */
define(function (require, exports, module) {
    const $ = require('jquery');
    const MicroEvent = require('mrg-microevent');
    const OfficeOnlineFrame = require('lib/OfficeOnlineFrame');
    const { initAndLoadR7 } = require('Cloud/Application/r7helpers');
    const { initAndLoadMyOffice } = require('Cloud/Application/Editor/MyOffice/myOffice.helpers');
    const { MYOFFICE_VARIANTS } = require('Cloud/Application/Editor/MyOffice/myOffice.types');
    const { isWopiEnabled, wopiFallbackConfig } = require('reactApp/appHelpers/featuresHelpers');

    var instance;
    const SHOW_TIMEOUT = 30000;

    var Editor = function (settings) {
        this._settings = settings || {};

        if (instance) {
            return instance;
        }
    };

    Editor.prototype = {
        constructor: Editor,

        initShowIframe(iframe, hided) {
            iframe.style.opacity = '1';

            if (hided) {
                iframe.style.height = '100%';
                iframe.style.width = '100%';
            }
        },

        hideIframe(iframe) {
            iframe.style.opacity = '0';
            iframe.style.height = '0';
            iframe.style.width = '0';
            iframe.style.border = '0';
        },

        start(container, url, mode, params) {
            var editor = this;
            var deferred = new $.Deferred();

            if (editor._officeOnlineFrame) {
                editor._officeOnlineFrame.dispose();
            }

            if (container.length) {
                container = container[0];
            }

            const isMyofficeForCloud = editor._settings.editorId === 'myoffice';
            const isMyofficeForAttaches = editor._settings.editorId === 'myofficeAttaches';

            if (isMyofficeForCloud || isMyofficeForAttaches) {
                const item = app.get(app.getState().id);

                let timerId = setTimeout(function () {
                    deferred.reject();
                    editor.emit('timeout');
                }, SHOW_TIMEOUT);

                // старые форматы редактировать все равно нельзя
                const myOfficeVariant = isWopiEnabled ? MYOFFICE_VARIANTS.wopi : MYOFFICE_VARIANTS.amr;

                const iframeAmr = document.createElement('iframe');

                container.appendChild(iframeAmr);

                let iframeWopi = null;
                if (myOfficeVariant === MYOFFICE_VARIANTS.wopi) {
                    iframeWopi = document.createElement('iframe');
                    container.appendChild(iframeWopi);

                    // Скрываем amr, тк показываем wopi, но не удаляем совсем,
                    // потому что может быть сфолбечимся на него
                    this.hideIframe(iframeAmr);
                }

                const iframe = myOfficeVariant === MYOFFICE_VARIANTS.wopi ? iframeWopi : iframeAmr;

                const amrParams = {
                    item,
                    initShowAmrIframe: () => this.initShowIframe(iframeAmr, true),
                };

                const wopiParams = {
                    accessParams: params,
                    url,
                    wopiFallbackConfig,
                };

                const listeners = {
                    onLoad: () => {
                        if (timerId) {
                            clearTimeout(timerId);
                            timerId = null;
                        }

                        this.initShowIframe(iframe);

                        editor.emit('load');
                        editor.emit('start', params);
                        deferred.resolve();
                    },
                    onError: () => {
                        this.initShowIframe(iframe);
                        deferred.reject();
                        editor.emit('error');
                    },
                };

                initAndLoadMyOffice({
                    iframeAmr,
                    iframeWopi,
                    documentMode: mode,
                    wopiParams,
                    amrParams,
                    myOfficeVariant,
                    listeners,
                    container,
                    isEditAttaches: isMyofficeForAttaches,
                });
            } else if (editor._settings.editorId === 'R7') {
                editor._officeOnlineFrame = document.createElement('div');
                editor._officeOnlineFrame.id = 'r7-placeholder';
                $(editor._officeOnlineFrame).appendTo(container);

                let timerId = setTimeout(function () {
                    deferred.reject();
                    editor.emit('timeout');
                }, SHOW_TIMEOUT);

                initAndLoadR7(url, {
                    mode,
                    placeholderId: editor._officeOnlineFrame.id,
                    container,
                    onDocumentReady: function () {
                        if (timerId) {
                            clearTimeout(timerId);
                            timerId = null;
                        }
                        deferred.resolve();
                        editor.emit('load');
                        editor.emit('start', params);
                    },
                    onError: function (event) {
                        deferred.reject(event.data);
                        editor.emit('error');
                    },
                });
            } else {
                editor._officeOnlineFrame = new OfficeOnlineFrame({
                    url: url,
                    data: params,

                    onFrameTimeout: function () {
                        deferred.reject();
                        editor.emit('error');
                    },

                    onFrameError: function () {
                        deferred.reject();
                        editor.emit('error');
                    },

                    onFrameLoad: function () {
                        deferred.resolve();
                        editor.emit('load');
                    },

                    onTimeout: function () {
                        editor.emit('timeout');
                    },

                    onSharing: function () {
                        editor.emit('sharing', {});
                    },

                    onRename: function (params) {
                        editor.emit('rename', params);
                    },

                    onStart: function (params) {
                        deferred.resolve();
                        editor.emit('start', params);
                    },

                    onClose: function (params) {
                        editor.emit('close', params);
                    },
                });

                editor._officeOnlineFrame.appendTo(container);
            }

            return deferred;
        },
    };

    MicroEvent.mixin(Editor.prototype);

    module.exports = Editor;
});
